import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import pedirSenhaAdmin from '../components/common/pedirSenhaAdmin';
import { limparDocumento, erroDocumento } from '../utils/documento';
import { navegarComEnter } from '../utils/enterNavegacao';
import s from './PedidosOrcamentos.module.css';

const TIPO_CONTRIBUINTE_OPTS = [
  '', 'Contribuinte ICMS', 'Consumidor Final', 'Não Contribuinte',
];

const UF_OPTS = [
  'AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT',
  'PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO',
];

const FORM_VAZIO = {
  id: null, codigo: '', nome_fantasia: '', razao_social: '', cpf_cnpj: '',
  tipo_contribuinte: '', ie: '', suframa: '',
  cep: '', logradouro: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '',
  site: '', email: '', contato: '', fone: '', observacoes: '', inativo: false,
  plano_conta_codigo: '',
};

const fmtMoeda = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtData  = str => str ? new Date(String(str).slice(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR') : '—';

function fornToForm(f) {
  return {
    id:               f.id || null,
    codigo:           f.codigo || '',
    nome_fantasia:    f.nome_fantasia || '',
    razao_social:     f.razao_social || '',
    cpf_cnpj:         f.cpf_cnpj || '',
    tipo_contribuinte: f.tipo_contribuinte || '',
    ie:               f.ie || '',
    suframa:          f.suframa || '',
    cep:              f.cep || '',
    logradouro:       f.logradouro || '',
    numero:           f.numero || '',
    complemento:      f.complemento || '',
    bairro:           f.bairro || '',
    cidade:           f.cidade || '',
    uf:               f.uf || '',
    site:             f.site || '',
    email:            f.email || '',
    contato:          f.contato || '',
    fone:             f.fone || '',
    observacoes:      f.observacoes || '',
    inativo:          f.inativo || false,
    plano_conta_codigo: f.plano_conta_codigo || '',
  };
}

/* ── Modal Busca de Fornecedor ── */
function ModalBuscaFornecedor({ onSelect, onClose }) {
  const [busca, setBusca]       = useState('');
  const [lista, setLista]       = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [selIdx, setSelIdx]     = useState(null);
  const [verInativo, setVerInativo] = useState(false);

  const pesquisar = useCallback(async (texto, incInativo) => {
    setCarregando(true);
    setSelIdx(null);
    try {
      const params = {};
      if (texto) params.busca = texto;
      if (incInativo) params.inativo = 'true';
      const { data } = await api.get('/fornecedores', { params });
      setLista(Array.isArray(data) ? data : []);
    } catch { setLista([]); }
    finally { setCarregando(false); }
  }, []);

  useEffect(() => { pesquisar('', false); }, [pesquisar]);

  const selecionar = (f) => { if (f) onSelect(f); };

  useEffect(() => {
    const h = e => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'Enter' && selIdx !== null) selecionar(lista[selIdx]);
      if (e.key === 'ArrowDown') setSelIdx(i => i === null ? 0 : Math.min(i + 1, lista.length - 1));
      if (e.key === 'ArrowUp')   setSelIdx(i => i === null ? 0 : Math.max(i - 1, 0));
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [selIdx, lista]); // eslint-disable-line

  return (
    <div className={s.overlay} data-enter-scope="off" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className={s.modal} style={{ width: 680 }}>
        <div className={s.modalTitle} style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Busca de Fornecedores</span>
          <button style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 15 }}
            onClick={onClose}>✕</button>
        </div>
        <div className={s.modalBody}>
          <div className={s.modalSearchRow}>
            <input className={s.inputErp} style={{ flex: 1 }}
              placeholder="Nome fantasia, razão social, CPF/CNPJ..."
              value={busca}
              onChange={e => setBusca(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && pesquisar(busca, verInativo)}
              autoFocus />
            <label style={{ display: 'flex', gap: 4, alignItems: 'center', fontSize: 12 }}>
              <input type="checkbox" checked={verInativo} onChange={e => setVerInativo(e.target.checked)} />
              Inativos
            </label>
            <button className={s.btnErp} onClick={() => pesquisar(busca, verInativo)}>
              {carregando ? '...' : 'Buscar'}
            </button>
          </div>
          <div style={{ overflowY: 'auto', maxHeight: 340, border: '1px solid #ccc' }}>
            <table className={s.modalTabela}>
              <thead>
                <tr>
                  <th style={{ width: 50 }}>Cód.</th>
                  <th>Nome Fantasia</th>
                  <th>Razão Social</th>
                  <th style={{ width: 130 }}>CPF/CNPJ</th>
                  <th style={{ width: 80 }}>Cidade/UF</th>
                </tr>
              </thead>
              <tbody>
                {lista.length === 0 && (
                  <tr><td colSpan={5} style={{ textAlign: 'center', padding: 16, color: '#888', fontStyle: 'italic' }}>
                    {carregando ? 'Buscando...' : 'Nenhum fornecedor encontrado.'}
                  </td></tr>
                )}
                {lista.map((f, i) => (
                  <tr key={f.id}
                    className={selIdx === i ? s.selRow : ''}
                    onClick={() => setSelIdx(i)}
                    onDoubleClick={() => selecionar(f)}>
                    <td>{f.codigo}</td>
                    <td>{f.nome_fantasia}</td>
                    <td>{f.razao_social}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: 11 }}>{f.cpf_cnpj}</td>
                    <td>{f.cidade}{f.uf ? `/${f.uf}` : ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className={s.modalFooter}>
          <button className={`${s.btnErp} ${s.btnErpPrimario}`}
            disabled={selIdx === null}
            onClick={() => selIdx !== null && selecionar(lista[selIdx])}>
            Selecionar
          </button>
          <button className={s.btnErp} onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════
   Componente Principal
══════════════════════════════════ */
export default function Fornecedores() {
  const [lista,      setLista]      = useState([]);
  const [posicao,    setPosicao]    = useState(0);
  const [form,       setForm]       = useState({ ...FORM_VAZIO });
  const [modo,       setModo]       = useState('nav'); // 'nav' | 'novo' | 'editar'
  const [erroSalvar, setErroSalvar] = useState('');
  const [salvando,   setSalvando]   = useState(false);
  const [modalBusca, setModalBusca] = useState(false);
  const [buscandoCep,  setBuscandoCep]  = useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [planoContas,  setPlanoContas]  = useState([]);

  const editando = modo === 'novo' || modo === 'editar';

  /* ── Carregar lista ── */
  const carregarLista = useCallback(async () => {
    try {
      const { data } = await api.get('/fornecedores');
      const lst = Array.isArray(data) ? data : [];
      setLista(lst);
      return lst;
    } catch { return []; }
  }, []);

  /* ── Carregar por ID ── */
  const carregarFornecedor = useCallback(async (id, lst, pos) => {
    try {
      const { data } = await api.get(`/fornecedores/${id}`);
      setForm(fornToForm(data));
      setPosicao(pos);
    } catch { setForm({ ...FORM_VAZIO }); }
  }, []);

  /* ── Init ── */
  useEffect(() => {
    carregarLista().then(lst => {
      if (lst.length > 0) carregarFornecedor(lst[0].id, lst, 0);
    });
    // Despesa/custo — mesmo filtro de tipo usado em ContasPagar.jsx, já que
    // é pra onde esse plano padrão vai ser puxado (Contas a Pagar).
    api.get('/financeiro/plano-contas/analiticas', { params: { tipo: 'despesa,custo' } })
      .then(r => setPlanoContas(r.data || [])).catch(() => {});
  }, []); // eslint-disable-line

  const set = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));

  /* ── Navegação ── */
  const navAnterior = () => {
    if (posicao <= 0) return;
    const np = posicao - 1;
    carregarFornecedor(lista[np].id, lista, np);
  };
  const navProximo = () => {
    if (posicao >= lista.length - 1) return;
    const np = posicao + 1;
    carregarFornecedor(lista[np].id, lista, np);
  };

  /* ── Novo ── */
  const handleNovo = () => {
    setForm({ ...FORM_VAZIO });
    setErroSalvar('');
    setModo('novo');
  };

  /* ── Alterar ── */
  const handleAlterar = () => {
    setErroSalvar('');
    setModo('editar');
  };

  /* ── Cancelar ── */
  const handleCancelar = () => {
    setModo('nav');
    setErroSalvar('');
    if (form.id) {
      carregarFornecedor(form.id, lista, posicao);
    } else if (lista.length > 0) {
      carregarFornecedor(lista[0].id, lista, 0);
    } else {
      setForm({ ...FORM_VAZIO });
    }
  };

  /* ── Salvar ── */
  const handleSalvar = async () => {
    if (!form.nome_fantasia?.trim()) {
      setErroSalvar('Nome Fantasia é obrigatório.');
      return;
    }
    // CNPJ alfanumérico (NT 2026.004): valida DV antes de salvar
    const erroDoc = erroDocumento(form.cpf_cnpj);
    if (erroDoc) { setErroSalvar(erroDoc); return; }
    setSalvando(true);
    setErroSalvar('');
    try {
      const payload = { ...form };
      let savedId;
      if (modo === 'novo') {
        const { data } = await api.post('/fornecedores', payload);
        savedId = data.id;
      } else {
        await api.put(`/fornecedores/${form.id}`, payload);
        savedId = form.id;
      }
      const lst = await carregarLista();
      const pos = lst.findIndex(f => f.id === savedId);
      await carregarFornecedor(savedId, lst, pos >= 0 ? pos : 0);
      setModo('nav');
    } catch (err) {
      setErroSalvar(err.response?.data?.erro || 'Erro ao salvar.');
    } finally {
      setSalvando(false);
    }
  };

  /* ── Excluir (senha de admin; bloqueado se houver movimentação) ── */
  const excluirComSenha = async (id) => {
    try {
      await api.delete(`/fornecedores/${id}`);
      return true;
    } catch (err) {
      if (!err.response?.data?.exige_admin) throw err;
      const senha = await pedirSenhaAdmin(
        `Excluir o fornecedor "${form.nome_fantasia}" exige autorização de administrador.`,
        { acao: 'excluir_fornecedor', detalhes: `Fornecedor #${id} — ${form.nome_fantasia}` });
      if (senha === null) return false;
      await api.delete(`/fornecedores/${id}`, { data: { senha_admin: senha } });
      return true;
    }
  };

  const handleExcluir = async () => {
    if (!form.id) return;
    if (!window.confirm(`Inativar fornecedor "${form.nome_fantasia}"?`)) return;
    try {
      if (!(await excluirComSenha(form.id))) return;
      const lst = await carregarLista();
      if (lst.length > 0) {
        const np = Math.min(posicao, lst.length - 1);
        await carregarFornecedor(lst[np].id, lst, np);
      } else {
        setForm({ ...FORM_VAZIO });
        setPosicao(0);
      }
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao excluir.');
    }
  };

  /* ── Buscar CNPJ ── */
  const handleBuscarCnpj = async () => {
    const cnpj = limparDocumento(form.cpf_cnpj); // preserva letras (CNPJ alfanumérico)
    if (!cnpj || cnpj.length !== 14) {
      alert('Informe um CNPJ válido (14 caracteres).');
      return;
    }
    setBuscandoCnpj(true);
    try {
      const { data } = await api.get(`/fornecedores/buscar-cnpj/${cnpj}`);
      setForm(f => ({
        ...f,
        razao_social: data.razao_social || f.razao_social,
        nome_fantasia: data.nome_fantasia || f.nome_fantasia,
        ie:            data.ie || f.ie,
        email:         data.email || f.email,
        logradouro:    data.logradouro || f.logradouro,
        numero:        data.numero || f.numero,
        complemento:   data.complemento || f.complemento,
        bairro:        data.bairro || f.bairro,
        cidade:        data.cidade || f.cidade,
        uf:            data.uf || f.uf,
        cep:           data.cep || f.cep,
        fone:          data.fone || f.fone,
      }));
    } catch (err) {
      alert(err.response?.data?.erro || 'Erro ao consultar CNPJ.');
    } finally {
      setBuscandoCnpj(false);
    }
  };

  /* ── Buscar CEP ── */
  const handleBuscarCep = async () => {
    const cep = form.cep?.replace(/\D/g, '');
    if (!cep || cep.length !== 8) return;
    setBuscandoCep(true);
    try {
      const resp = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await resp.json();
      if (!data.erro) {
        setForm(f => ({
          ...f,
          logradouro:  data.logradouro || f.logradouro,
          complemento: data.complemento || f.complemento,
          bairro:      data.bairro || f.bairro,
          cidade:      data.localidade || f.cidade,
          uf:          data.uf || f.uf,
        }));
      }
    } catch { /* silencioso */ }
    finally { setBuscandoCep(false); }
  };

  /* ── Status text ── */
  const statusText = () => {
    if (erroSalvar) return <span className={s.statusErro}>{erroSalvar}</span>;
    if (modo === 'novo')   return <span className={s.statusNovo}>Novo fornecedor</span>;
    if (modo === 'editar') return <span className={s.statusEditar}>Editando: {form.nome_fantasia}</span>;
    if (form.id) return `Fornecedor ${form.codigo} — ${form.nome_fantasia}${form.inativo ? ' [INATIVO]' : ''}`;
    return lista.length === 0 ? 'Nenhum fornecedor cadastrado.' : '';
  };

  return (
    <div className={s.erpWrap} data-enter-scope="on" onKeyDown={navegarComEnter}>
      {/* Barra de título */}
      <div className={s.titleBar}>
        <span>🏭</span> Cadastro de Fornecedores
      </div>

      {/* Conteúdo */}
      <div className={s.tabContent} style={{ overflowY: 'auto' }}>

        {/* Linha 1: Código | Nome Fantasia | Inativo */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 4, alignItems: 'flex-end' }}>
          <div className={s.headerGroup}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Cód.</span>
            <input className={s.inputErp} style={{ width: 58 }}
              value={form.codigo} readOnly tabIndex={-1} />
          </div>
          <div className={s.headerGroup} style={{ flex: 1 }}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Nome Fantasia *</span>
            <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
              value={form.nome_fantasia}
              readOnly={!editando}
              onChange={e => set('nome_fantasia', e.target.value)} />
          </div>
          <div className={s.headerGroup}>
            <label style={{ display: 'flex', gap: 4, alignItems: 'center', fontSize: 12 }}>
              <input type="checkbox"
                checked={form.inativo}
                disabled={!editando}
                onChange={e => set('inativo', e.target.checked)} />
              Inativo
            </label>
          </div>
        </div>

        {/* Linha 2: CPF/CNPJ + lupa | Razão Social */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
          <div className={s.headerGroup} style={{ width: 220 }}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>CPF/CNPJ</span>
            <input className={s.inputErp} style={{ width: 140 }}
              value={form.cpf_cnpj}
              readOnly={!editando}
              onChange={e => set('cpf_cnpj', e.target.value)}
              placeholder="00.000.000/0000-00" />
            {editando && (
              <button className={s.btnLookup}
                onClick={handleBuscarCnpj}
                disabled={buscandoCnpj}
                title="Consultar CNPJ na Receita Federal">
                {buscandoCnpj ? '...' : '🔍'}
              </button>
            )}
          </div>
          <div className={s.headerGroup} style={{ flex: 1 }}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Razão Social</span>
            <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
              value={form.razao_social}
              readOnly={!editando}
              onChange={e => set('razao_social', e.target.value)} />
          </div>
        </div>

        {/* Linha 3: Tipo Contribuinte | IE | Suframa */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
          <div className={s.headerGroup}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Tipo Contribuinte</span>
            <select className={s.selectErp} style={{ width: 170 }}
              value={form.tipo_contribuinte}
              disabled={!editando}
              onChange={e => set('tipo_contribuinte', e.target.value)}>
              {TIPO_CONTRIBUINTE_OPTS.map(o => <option key={o} value={o}>{o || '— Selecione —'}</option>)}
            </select>
          </div>
          <div className={s.headerGroup}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>I.E.</span>
            <input className={s.inputErp} style={{ width: 120 }}
              value={form.ie}
              readOnly={!editando}
              onChange={e => set('ie', e.target.value)} />
          </div>
          <div className={s.headerGroup}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>SUFRAMA</span>
            <input className={s.inputErp} style={{ width: 100 }}
              value={form.suframa}
              readOnly={!editando}
              onChange={e => set('suframa', e.target.value)} />
          </div>
        </div>

        {/* Linha 4: Fone | E-mail | Site */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
          <div className={s.headerGroup}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Fone</span>
            <input className={s.inputErp} style={{ width: 140 }}
              value={form.fone}
              readOnly={!editando}
              onChange={e => set('fone', e.target.value)} />
          </div>
          <div className={s.headerGroup}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Contato</span>
            <input className={s.inputErp} style={{ width: 140 }}
              value={form.contato}
              readOnly={!editando}
              onChange={e => set('contato', e.target.value)} />
          </div>
          <div className={s.headerGroup} style={{ flex: 1 }}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>E-mail</span>
            <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
              value={form.email}
              readOnly={!editando}
              onChange={e => set('email', e.target.value)} />
          </div>
          <div className={s.headerGroup} style={{ flex: 1 }}>
            <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Site</span>
            <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
              value={form.site}
              readOnly={!editando}
              onChange={e => set('site', e.target.value)} />
          </div>
        </div>

        {/* Fieldset Endereço */}
        <fieldset className={s.fieldset}>
          <legend className={s.legend}>Endereço</legend>

          {/* CEP + Logradouro + Número */}
          <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
            <div className={s.campo}>
              <span className={s.campoLabel}>CEP</span>
              <input className={s.inputErp} style={{ width: 90 }}
                value={form.cep}
                readOnly={!editando}
                onChange={e => set('cep', e.target.value)}
                onBlur={handleBuscarCep}
                placeholder="00000-000" />
              {editando && (
                <button className={s.btnLookup}
                  onClick={handleBuscarCep}
                  disabled={buscandoCep}
                  title="Buscar CEP">
                  {buscandoCep ? '...' : '🔍'}
                </button>
              )}
            </div>
            <div className={s.campo} style={{ flex: 1 }}>
              <span className={s.campoLabel}>Logradouro</span>
              <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
                value={form.logradouro}
                readOnly={!editando}
                onChange={e => set('logradouro', e.target.value)} />
            </div>
            <div className={s.campo}>
              <span className={s.campoLabel} style={{ minWidth: 'auto' }}>Número</span>
              <input className={s.inputErp} style={{ width: 80 }}
                value={form.numero}
                readOnly={!editando}
                onChange={e => set('numero', e.target.value)} />
            </div>
          </div>

          {/* Complemento + Bairro */}
          <div style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
            <div className={s.campo} style={{ flex: 1 }}>
              <span className={s.campoLabel}>Complemento</span>
              <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
                value={form.complemento}
                readOnly={!editando}
                onChange={e => set('complemento', e.target.value)} />
            </div>
            <div className={s.campo} style={{ flex: 1 }}>
              <span className={s.campoLabel}>Bairro</span>
              <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
                value={form.bairro}
                readOnly={!editando}
                onChange={e => set('bairro', e.target.value)} />
            </div>
          </div>

          {/* Cidade + UF */}
          <div style={{ display: 'flex', gap: 6 }}>
            <div className={s.campo} style={{ flex: 1 }}>
              <span className={s.campoLabel}>Cidade</span>
              <input className={s.inputErp} style={{ flex: 1, minWidth: 0 }}
                value={form.cidade}
                readOnly={!editando}
                onChange={e => set('cidade', e.target.value)} />
            </div>
            <div className={s.campo}>
              <span className={s.campoLabel} style={{ minWidth: 'auto' }}>UF</span>
              <select className={s.selectErp} style={{ width: 60 }}
                value={form.uf}
                disabled={!editando}
                onChange={e => set('uf', e.target.value)}>
                <option value="">--</option>
                {UF_OPTS.map(u => <option key={u} value={u}>{u}</option>)}
              </select>
            </div>
          </div>
        </fieldset>

        {/* Fieldset Financeiro */}
        <fieldset className={s.fieldset}>
          <legend className={s.legend}>Financeiro</legend>
          <div className={s.campo}>
            <span className={s.campoLabel} style={{ minWidth: 140 }}>Plano de Contas padrão</span>
            <select className={s.selectErp} style={{ minWidth: 260 }}
              value={form.plano_conta_codigo}
              disabled={!editando}
              onChange={e => set('plano_conta_codigo', e.target.value)}>
              <option value="">— Nenhum —</option>
              {planoContas.map(pc => (
                <option key={pc.id} value={pc.codigo}>{pc.codigo} — {pc.descricao}</option>
              ))}
            </select>
            <span style={{ fontSize: 11, color: '#888', marginLeft: 8 }}>
              Sugerido automaticamente ao lançar uma Contas a Pagar pra este fornecedor — pode ser trocado na hora.
            </span>
          </div>
        </fieldset>

        {/* Fieldset Observações */}
        <fieldset className={s.fieldset}>
          <legend className={s.legend}>Observações</legend>
          <textarea className={s.textareaObs} style={{ minHeight: 80 }}
            value={form.observacoes}
            readOnly={!editando}
            onChange={e => set('observacoes', e.target.value)} />
        </fieldset>
      </div>

      {/* Status bar */}
      <div className={s.statusBar}>{statusText()}</div>

      {/* Footer */}
      <div className={s.footer}>
        <div className={s.footerLeft}>
          <button className={`${s.btnErp} ${s.btnErpNav}`}
            onClick={navAnterior}
            disabled={editando || posicao <= 0}>&lt;</button>
          <span className={s.footerPos}>
            {lista.length ? `${posicao + 1}/${lista.length}` : '0/0'}
          </span>
          <button className={`${s.btnErp} ${s.btnErpNav}`}
            onClick={navProximo}
            disabled={editando || posicao >= lista.length - 1}>&gt;</button>
        </div>
        <div className={s.footerRight}>
          <button className={s.btnErp} onClick={handleNovo} disabled={editando}>Novo</button>
          <button className={s.btnErp} onClick={() => setModalBusca(true)} disabled={editando}>Buscar</button>
          <button className={s.btnErp} onClick={handleAlterar} disabled={editando || !form.id}>Alterar</button>
          <button className={s.btnErp} onClick={handleCancelar} disabled={!editando}>Cancelar</button>
          <button className={`${s.btnErp} ${s.btnErpPerigo}`}
            onClick={handleExcluir}
            disabled={editando || !form.id}>Excluir</button>
          <button className={`${s.btnErp} ${s.btnErpPrimario}`} data-enter-final
            onClick={handleSalvar}
            disabled={!editando || salvando}>
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
          <div className={s.footerSep} />
          <button className={s.btnErp} onClick={() => window.history.back()}>Sair</button>
        </div>
      </div>

      {/* Modal busca */}
      {modalBusca && (
        <ModalBuscaFornecedor
          onClose={() => setModalBusca(false)}
          onSelect={async f => {
            setModalBusca(false);
            const lst = await carregarLista();
            const pos = lst.findIndex(x => x.id === f.id);
            await carregarFornecedor(f.id, lst, pos >= 0 ? pos : 0);
          }}
        />
      )}
    </div>
  );
}
